import { STANDARD_BRANCH } from '@festina-life/api'
import type { ConfigurableServer } from '@festina-life/core'

import { useNavigationParams } from '../../system/useNavigationParams'
import { Attribute } from '../attribute/Attribute'
import { StandardBranchNameAndCategory } from './StandardBranchNameAndCategory'

type Props = {
  server: ConfigurableServer
}

export const StandardBranchStatus = ({ server }: Props) => {
  const { server: currentServer, branch } = useNavigationParams()
  const isActive = server === currentServer && branch === STANDARD_BRANCH

  return (
    <Attribute
      isFaded={false}
      className={
        isActive ? 'bg-success-300! text-amaze-ink!' : 'bg-transparent!'
      }
    >
      <StandardBranchNameAndCategory />
    </Attribute>
  )
}
